<div id="footer" class="container-fluid">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-2 align__text-center">
        <img src="assets/img/logo_zeeker_blanco.png" alt="Zeeker Solutions">
        <div class="col-12 footer-text" style="color:aqua; text-align: start">
          #WeZEEKER4u
        </div>
        <div class=" col col-md-9 icons_footer">
          <a href="https://www.linkedin.com/company/zeeker-solutions/" class="rrss linkedin" target="_blank">
            <img src="assets/svg/linkedin.svg" alt="linkedin" class="filter">
          </a>
          <a href="https://www.instagram.com/zeeker.solutions/" class="rrss instagram" target="_blank">
            <img src="assets/img/instagram.png" alt="">
          </a>
          <a href="https://www.facebook.com/zeekersol/" class="rrss facebook" target="_blank">
            <img src="assets/svg/facebook-logo.svg" alt="facebook" class="filter">
          </a>
          <a href="https://twitter.com/ZeekerSolutions" class="rrss x" target="_blank">
            <img src="assets/img/x.png" alt="twitter" class="filter">
          </a>
        </div>i

      </div>

      <div class="col-md-12 col-lg-1"></div>

      <div class="col-md-12 col-lg-4 info-b">

        <span class="location col-2">
          <img src="assets/svg/location.svg" alt="location" class="teal-filter">
        </span>

        <div class="col-10">
          <h2 class="col-12 footer-title">Dirección España</h2>
          <p class="col-12 footer-text">Calle Henri Dunant 15-17 28036.</p>
          <p class="col-12 footer-text">Madrid, España</p>
        </div>



      </div>

      <div class="col-md-12 col-lg-2">

        <div class="info">
          <h3 class="footer-title">
            Contacto
          </h3>
          <p class="footer-text">
            <a href="mailto:admin@zeeker.es">admin&#64;zeeker.es</a><br>
            <a href="tel:+34660769358">+34 660 769 358</a>
          </p>
        </div>


        <div class="info">
          <h3 class="footer-title">
            Únete a Zeeker
          </h3>
          <p class="footer-text">
            <a href="mailto:rrhh@zeeker.es">rrhh&#64;zeeker.es</a><br>
          </p>
        </div>

      </div>

      <div class="col-md-12 col-lg-3">
        <h3 class="footer-title">
          Aviso Legal
        </h3>

        <a class="footer-text blue" routerLink="/aviso-legal/terminos">
          Términos y condiciones
        </a>
        <br>
        <a class="footer-text blue" routerLink="/aviso-legal/privacidad">
          Política de privacidad & legal
        </a>
        <br>
        <a class="footer-text blue" routerLink="/aviso-legal/cookies">
          Cookies
        </a>
      </div>

    </div>
    <div class="row">
      <hr class="separated">
      <div class="col-s-12 align__text-center w100">
        <p class="footer-text_copy">© Copyright Zeeker Solutions {{ today | date:'yyyy' }}</p>
      </div>
    </div>
  </div>
</div>